<div class="container-fluid allt">
  <div class="myndatexti">
    <h1>Skíðakennsla Oddnýjar <br>og Sveins Gauta</h1>
  </div>
</div>
